jQuery(document).ready(function(){
		jQuery('.login-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		infinite: false,
	});
	jQuery('.home-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		pauseOnHover: false,
		arrows: false,
        dots: true,
		infinite: true,
        autoplay: true,
        autoplaySpeed: 28000,
	});
	var isPlaying = true;

	$('#sliderplaybtn').click(function() {
		if (isPlaying) {
			$('.home-slider').slick('slickPause');
			$(this).html(`
				<svg class="pause-icon" width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M17.5915 11.1673L3.55868 3.04989C3.50205 3.0172 3.43782 2.99999 3.37244 3C3.30706 3.00001 3.24283 3.01724 3.18622 3.04995C3.1296 3.08266 3.0826 3.12969 3.04994 3.18633C3.01727 3.24297 3.0001 3.30721 3.00014 3.37259V19.5974C2.99832 19.6636 3.01419 19.7291 3.04613 19.7872C3.07807 19.8452 3.12491 19.8937 3.18183 19.9276C3.23874 19.9615 3.30367 19.9796 3.36992 19.98C3.43616 19.9804 3.50132 19.9632 3.55868 19.93L17.5915 11.8127C17.6483 11.78 17.6954 11.733 17.7281 11.6763C17.7609 11.6197 17.7781 11.5554 17.7781 11.49C17.7781 11.4245 17.7609 11.3602 17.7281 11.3036C17.6954 11.2469 17.6483 11.1999 17.5915 11.1673ZM3.74485 18.952V4.02794L16.6681 11.49L3.74485 18.952Z" fill="white"></path>
				</svg>
			`);
		} else {
			$('.home-slider').slick('slickPlay');
			$(this).html(`
				<svg class="play-icon" width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M7.79997 20.1307H3.85997C3.29997 20.1307 2.83997 19.6069 2.83997 18.9693V3.98512C2.83997 3.34749 3.29997 2.82373 3.85997 2.82373H7.79997C8.35997 2.82373 8.81997 3.34749 8.81997 3.98512V18.992C8.79997 19.6069 8.35997 20.1307 7.79997 20.1307ZM3.85997 3.73462C3.73997 3.73462 3.63997 3.84848 3.63997 3.98512V18.992C3.63997 19.1287 3.73997 19.2425 3.85997 19.2425H7.79997C7.91997 19.2425 8.01997 19.1287 8.01997 18.992V3.98512C8.01997 3.84848 7.91997 3.73462 7.79997 3.73462H3.85997Z" fill="white"></path>
				<path d="M15.52 20.1307H11.6C11.04 20.1307 10.58 19.6069 10.58 18.9693V3.98512C10.58 3.34749 11.04 2.82373 11.6 2.82373H15.52C16.08 2.82373 16.54 3.34749 16.54 3.98512V18.992C16.54 19.6069 16.08 20.1307 15.52 20.1307ZM11.6 3.73462C11.48 3.73462 11.38 3.84848 11.38 3.98512V18.992C11.38 19.1287 11.48 19.2425 11.6 19.2425H15.52C15.64 19.2425 15.74 19.1287 15.74 18.992V3.98512C15.74 3.84848 15.64 3.73462 15.52 3.73462H11.6Z" fill="white"></path>
				</svg>
			`);
		}
		isPlaying = !isPlaying;
	});

	// jQuery('.product-card-slider').slick({
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	infinite: false,
	// 	asNavFor: '.product-nav-slider',
	// });
	// jQuery('.product-nav-slider').slick({
	// 	slidesToShow: 5,
	// 	slidesToScroll: 1,
	// 	swipeToSlide: false,
	// 	asNavFor: '.product-card-slider',
	// 	dots: false,
	// 	arrows: false,
	// 	infinite: false,
	// 	vertical:false,
	// 	focusOnSelect: true,
	// 	responsive: [
			
	// 		{
	// 			breakpoint: 767,
	// 			settings: {
	// 				arrows: true,
	// 				vertical:false,
	// 				dots: false,
	// 				slidesToShow: 4,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
	jQuery('.product-features-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	
	jQuery('.wear-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
 $('.topbar-slider').on('init', function(){
    $(this).css('visibility', 'visible'); 
  }).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    infinite: true
  });
	jQuery('.shopby-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: true,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
	// jQuery('.similar-slider').slick({
	// 	slidesToShow: 4,
	// 	slidesToScroll: 1,
	// 	arrows: true,
	// 	infinite: false,
	// 	responsive: [
	// 		{
	// 			breakpoint: 991,
	// 			settings: {
	// 				slidesToShow: 3,
	// 				slidesToScroll: 1
	// 			}
	// 		},
	// 		{
	// 			breakpoint: 767,
	// 			settings: {
	// 				arrows: false,
	// 				dots: false,
	// 				slidesToShow: 2,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
	jQuery('.combo-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.similar-popup-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
    /*
	jQuery('.curated-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.recently-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
    */
	jQuery('.about-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots:true,
		// infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.women-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					dots: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
  jQuery('.jdgm-write-rev-link').click(function() {
		jQuery(".review-btn").toggleClass('reviewfull');
    });
	setTimeout(function() {
		jQuery('.category-tab li a, .combo-tab li a').on('click', function(){
			var target = jQuery(this).attr('data-rel');
		 jQuery('.category-tab li a, .combo-tab li a').removeClass('active');
			jQuery(this).addClass('active');
			jQuery("#"+target).fadeIn('slow').siblings(".plp-tab-box, .combo-tab-box").hide();
			jQuery('.product-card-slider, .product-nav-slider, .combo-slider').slick('setPosition');
		});
	}, 1000);
	// $('.size-btn .lotto-btn, .product-dec-bottom-right .lotto-btn').click(function() {
 //        // Toggle the text content
 //        const $textSpan = $(this).find('.size-txt');
 //        const currentText = $textSpan.text();
        
 //        // $textSpan.text(currentText === 'Select size' ? 'Add to Bag' : 'Select size');
        
 //        // Optional: Toggle a class for styling differences
 //        // $(this).toggleClass('added', currentText === 'Select size');
	// 	$(".size-guide").addClass('active');
 //        $(".product-details_add-cart").addClass('active');
 //        $(".product-details_seclect-size").toggleClass('active');
 //    });
	jQuery(document).on('click','.product-col .product-col-top', function(){
		jQuery(this).parent(".product-col").toggleClass('active').siblings().removeClass('active');
	});
		// $(".verify-btn").click(function(){
	// 	$(".complete").addClass('completeshow');
	// 	$(".onboarding-box").addClass('hideonboarding');
	// });
  $(".product-details_add-cart").click(function(){
			$("#addcart-popup").addClass('addcartshow');
		});
		// $(".gokwik-checkout .button").click(function(){
		// 	$("#addcart-popup").removeClass('addcartshow');
		// });

  const header = $('.header');
  let lastScroll = 0;

  $(window).scroll(function() {
    const currentScroll = $(this).scrollTop();
    
    if (currentScroll > lastScroll && currentScroll > 50) {
      // Scroll down
      header.addClass('sticky');
      $('main').css('padding-top', header.outerHeight() + 'px');
    } else if (currentScroll + $(window).height() < $(document).height() && currentScroll <= 50) {
      // Near top of page
      header.removeClass('sticky');
      $('main').css('padding-top', '0');
    }
    
    lastScroll = currentScroll;
  });

  // Handle window resize
  $(window).resize(function() {
    if (header.hasClass('sticky')) {
      $('main').css('padding-top', header.outerHeight() + 'px');
    }
  });
  jQuery('.blogs-slider').slick({
			slidesToShow: 2.5,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
    	responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 1.5,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.featured-slider').slick({
			slidesToShow: 3.5,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
    	responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 2.3,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.pdp-features-slider').slick({
		slidesToShow: 3.5,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
    	responsive: [
			{
				breakpoint: 1199,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 2.5,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 1.5,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.wear-sec-slider').slick({
		slidesToShow: 3.1,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
    	responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 1.5,
					slidesToScroll: 1
				}
			}
		]
	});
	jQuery('.featured-product-slider').slick({
		slidesToShow: 3.5,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
    	responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 2.3,
					slidesToScroll: 1
				}
			}
		]
	});
	$(".featurd-tab li").click(function () {
      let index = $(this).index();
      $(".featurd-tab li").removeClass("active");
      $(this).addClass("active");
      $(".featurd-product-tab").hide();
      $(".featurd-product-tab").eq(index).fadeIn();
	  jQuery('.featured-product-slider').slick('setPosition');
    });
	$(".size-left-top li").click(function () {
    let index = $(this).index();

    // Tab active
    $(".size-left-top li").removeClass("active");
    $(this).addClass("active");

    // Tab switch
    $(".size-guide-tab").hide();
    $(".size-guide-tab").eq(index).fadeIn();

    // Add class to .size-guide-sec based on clicked tab
    let selectedClass = $(this).data("tab"); // sizein or sizecm
    $(".size-guide-sec")
        .removeClass("sizein sizecm")   // remove old classes
        .addClass(selectedClass);       // add new class
});
	jQuery('.shop-collection-slider').slick({
		slidesToShow: 3.5,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
    	responsive: [
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					dots: false,
					infinite: false,
					slidesToShow: 2.3,
					slidesToScroll: 1
				}
			}
		]
	});
	// jQuery('.shop-the-main').slick({
	// 	slidesToShow: 3,
	// 	slidesToScroll: 1,
	// 	arrows: false,
	// 	infinite: false,
    // 	responsive: [
	// 		{
	// 			breakpoint: 767,
	// 			settings: {
	// 				arrows: false,
	// 				dots: false,
	// 				infinite: false,
	// 				slidesToShow: 2,
	// 				slidesToScroll: 1
	// 			}
	// 		}
	// 	]
	// });
	$(document).on("click", ".lotto-plp-atc-btn-desktop", function (e) {
    e.stopPropagation();

    let card = $(this).closest(".product-card");
    let dropdown = card.find(".wishlist_dropdown");

    // Close all other dropdowns
    // $(".wishlist_dropdown").not(dropdown).slideUp(200);
    $(".product-card").not(card).removeClass("active");
    $(".lotto-plp-atc-btn-desktop").not(this).removeClass("active");

    // Toggle this one
    // dropdown.slideToggle(200);
    card.toggleClass("active");
    $(this).toggleClass("active");
});

// Close dropdown when clicking outside
$(document).on("click", function () {
    // $(".wishlist_dropdown").slideUp(200);
    $(".product-card").removeClass("active");
    $(".lotto-plp-atc-btn-desktop").removeClass("active");
});
  
	if(window.matchMedia("(min-width: 768px)").matches){
		jQuery('.trends-slider').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: true,
			infinite: false,
		});
	}
  
	if(window.matchMedia("(max-width: 991px)").matches){
		$(".menu-icon").click(function(){
			$(".nav").addClass('navshow');
		});
		
		$(".nav-close").click(function(){
			$(".nav").removeClass('navshow');
			$(".nav-item, .menu-col").removeClass('active');
		});
		$('.nav').on('click', '.first-step, .second-step', function(e) {
			e.preventDefault();
			const $target = $(this).closest('.nav-item, .menu-col');
			$target.toggleClass('active').siblings().removeClass('active');
			
			// Close child menus when parent closes
			if (!$target.hasClass('active')) {
				$target.find('.active').removeClass('active');
			}
		});

		jQuery('.first-step-back, .second-step-back').click(function() {
			jQuery(this).closest(".nav-item, .menu-col").removeClass('active');
		});
	}

	if(window.matchMedia("(max-width: 767px)").matches){
      
  //       jQuery('.mobile-facets').on('click', function(){
		//  jQuery('.mobile-facets__disclosure').removeClass('menu-opening');
		// });
		jQuery('.product-details-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			infinite: false,
			asNavFor: '.product-item-slider',
		});
		jQuery('.product-item-slider').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			swipeToSlide: false,
			asNavFor: '.product-details-slider',
			dots: false,
			arrows: false,
			infinite: false,
			vertical:false,
			focusOnSelect: true,
		});
		jQuery('.cloud-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
		});
		jQuery(document).on('click','.seo-accordion .lottoxxsheading', function(){
			jQuery(this).parent(".seo-accordion").toggleClass('active').siblings().removeClass('active');
		});
		jQuery('.footer-mid .footer-col .lottoxxsheading').click( function(){
			jQuery(this).parent(".footer-col").toggleClass('active').siblings().removeClass('active');
		});
	}
});
document.addEventListener('DOMContentLoaded', function() {
	// Step elements
	const stepOne = document.querySelector('.login-stepone');
	const stepTwo = document.querySelector('.login-steptwo');
	const stepThree = document.querySelector('.login-stepthree');
	const completeProfile = document.querySelector('.complete');
	const onboarding = document.querySelector('.onboarding-box');
	
	// Buttons
	const loginTwoBtn = document.querySelector('.login-twobtn');
	const loginThreeBtn = document.querySelector('.login-threebtn');
	const editBtn = document.querySelector('.edit-btn');
	const verifyBtn = document.querySelector('.verify-btn');
  
	// Step 1  Step 2
	// if(loginTwoBtn) {
	//   loginTwoBtn.addEventListener('click', (e) => {
	// 	e.preventDefault();
	// 	stepOne.classList.add('d-none');
	// 	stepTwo.classList.add('show-steptwo');
	//   });
	// }
  
	// Step 2 → Step 3
	// if(loginThreeBtn) {
	//   loginThreeBtn.addEventListener('click', (e) => {
	// 	e.preventDefault();
	// 	stepTwo.classList.remove('show-steptwo');
	// 	stepThree.classList.add('show-stepthree');
	//   });
	// }
  
	// Step 3 → Step 2 (Edit button)
	// if(editBtn) {
	//   editBtn.addEventListener('click', (e) => {
	// 	e.preventDefault();
	// 	stepThree.classList.remove('show-stepthree');
	// 	stepTwo.classList.add('show-steptwo');
	//   });
	// }
	// if(verifyBtn) {
	// 	verifyBtn.addEventListener('click', (e) => {
	// 	  e.preventDefault();
	// 	  onboarding.classList.add('hideonboarding');
	// 	  completeProfile.classList.add('completeshow');
	// 	});
	//   }

	const faqItems = document.querySelectorAll('.footer-faq-item');
	if (faqItems.length > 0) {
		faqItems[0].classList.add('active');
	}
	const faqTops = document.querySelectorAll('.footer-faq-question');
	faqTops.forEach(top => {
		top.addEventListener('click', function () {
			const faqItem = this.closest('.footer-faq-item');
			const isActive = faqItem.classList.contains('active');
			faqItems.forEach(item => {
				item.classList.remove('active');
			});
			if (!isActive) {
				faqItem.classList.add('active');
			}
		});
	});
  });

// ###############################################################################################

	jQuery('.faq-col .faq-top').click( function(){
		jQuery(this).parent(".faq-col").toggleClass('active').siblings().removeClass('active');
	});
$(document).ready(function() {
  const slider = $('.trends-slider, .blogs-slider');
  const track = $('.scrollbar-track');
  const handle = $('.scrollbar-handle');
  let isDragging = false;
  let startX;
  let startLeft;

  function getTranslateX(element) {
    const transform = element.css('transform');
    if (!transform || transform === 'none') return 0;
    const matrix = transform.match(/^matrix\((.+)\)$/);
    if (matrix) {
      const values = matrix[1].split(', ');
      return parseFloat(values[4]);
    }
    const translate = transform.match(/translateX\((.+?)px\)/);
    return translate ? parseFloat(translate[1]) : 0;
  }

  function updateScrollbar() {
      const slick = slider.slick('getSlick');
    try{
      const slideCount = slick.slideCount;
      const slidesToShow = slick.options.slidesToShow || 1;
      const trackWidth = track.outerWidth();
      const handleWidth = (slidesToShow / slideCount) * trackWidth;
      
      handle.css('width', handleWidth);
      
      const currentSlide = slick.currentSlide;
      const maxScroll = trackWidth - handleWidth;
      const position = maxScroll > 0 ? (currentSlide / (slideCount - slidesToShow)) * maxScroll : 0;
      handle.css('transform', `translateX(${position}px)`);
      
    }catch(err){
      console.log(err)
    }
  }

  slider.on('init afterChange', updateScrollbar);

  handle.on('mousedown', function(e) {
    isDragging = true;
    startX = e.clientX;
    startLeft = getTranslateX(handle);
    handle.addClass('no-transition');
    e.preventDefault();
  });

  $(document).on('mousemove', function(e) {
    if (!isDragging) return;
    const deltaX = e.clientX - startX;
    let newLeft = startLeft + deltaX;
    const trackWidth = track.outerWidth();
    const handleWidth = handle.outerWidth();
    const maxScroll = trackWidth - handleWidth;
    
    newLeft = Math.max(0, Math.min(newLeft, maxScroll));
    handle.css('transform', `translateX(${newLeft}px)`);

    if (maxScroll > 0) {
      const slick = slider.slick('getSlick');
      const slideCount = slick.slideCount;
      const slidesToShow = slick.options.slidesToShow || 1;
      const slideIndex = Math.round((newLeft / maxScroll) * (slideCount - slidesToShow));
      slider.slick('slickGoTo', slideIndex);
    }
  });

  $(document).on('mouseup', function() {
    isDragging = false;
    handle.removeClass('no-transition');
  });

  $(window).on('resize', updateScrollbar);

  // Initialize Slick slider
  // slider.slick({
  //   arrows: false,
  //   dots: false,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   infinite: false,
  //   speed: 300
  // });
});



document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.size-head-tag');
 
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
 
      // Remove active class from all
      tabs.forEach(t => t.classList.remove('active'));
 
      // Add active class to clicked
      this.classList.add('active');
 
      // Get target section selector
      const targetSelector = this.getAttribute('data-target');
      const target = document.querySelector(targetSelector);
 
      if (target) {
        // Smooth scroll inside popup
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  });
//   function onCheckoutClicked() {
// 	// console.log("hi");
//   const popup = document.getElementById('addcart-popup');
//   if (popup) {
//     popup.classList.remove('addcartshow');
//     popup.style.display = 'none';
//   }

//   // continue checkout logic here
// }
});
